import { AxiosError } from 'axios';

export interface ServerError {
  message: string;
  detail: string;
}

export function isAuthenticationError(error: AxiosError<ServerError>) {
  return (
    // Strapi Error
    (error?.response?.status === 401 &&
      error?.response?.data?.message === 'Error validating jwt token') ||
    // Django Error
    (error?.response?.status === 403 &&
      error?.response?.data?.detail ===
        'Authentication credentials were not provided.')
  );
}

/*
	If the error is an Authentication error we handle that error in 
	components/frontend/src/apis/strutBackend.js file.
	If it's another error we just want to log that error using console.error
	to see the error in DataDog.
	If we need to make any extra action to handle the error (like show a toast), the logic should be added
	on the component that is makeng the API call.
*/
export function handleError(error: AxiosError<ServerError>) {
  if (!isAuthenticationError(error)) {
    console.error(error);
  }
}
